'use client'

import { Breakpoints } from '@fukku/styles/breakpoints'

import { pointOfInterestImageLoaderFactory } from '../../../../../utils/pointOfInterestImageLoaderFactory'
import type { PointOfInterestImage } from '../../../../Home.type'
import { getPointOfInterest } from '../../../utils/getPointOfInterest/getPointOfInterest'
import { BannerImage } from '../../Shared/BannerImage/BannerImage'

interface PromotionalBannerImageProps {
	readonly image: PointOfInterestImage
	readonly priority: boolean | undefined
}

const SMALL_ASPECT_RATIO = 1
const MEDIUM_HEIGHT = 5
const MEDIUM_WIDTH = 7
const MEDIUM_ASPECT_RATIO = MEDIUM_WIDTH / MEDIUM_HEIGHT
const LARGE_HEIGHT = 5
const LARGE_WIDTH = 7
const LARGE_ASPECT_RATIO = LARGE_WIDTH / LARGE_HEIGHT

export const PromotionalBannerImage = ({
	image,
	priority,
}: PromotionalBannerImageProps) => {
	const promotionalBannerImageLoader = pointOfInterestImageLoaderFactory(
		getPointOfInterest({ image }),
		(width) => {
			if (width <= Breakpoints.medium) {
				return width / SMALL_ASPECT_RATIO
			}
			if (width <= Breakpoints.large) {
				return width / MEDIUM_ASPECT_RATIO
			}
			return width / LARGE_ASPECT_RATIO
		}
	)

	return (
		<BannerImage
			image={image}
			sizes={'(max-width: 1023px) 100vw, 44vw'}
			imageLoader={promotionalBannerImageLoader}
			priority={priority}
		/>
	)
}
